import { render, staticRenderFns } from "./addDep.vue?vue&type=template&id=4022ba02&scoped=true"
import script from "./addDep.vue?vue&type=script&lang=js"
export * from "./addDep.vue?vue&type=script&lang=js"
import style0 from "./addDep.vue?vue&type=style&index=0&id=4022ba02&prod&lang=scss&scoped=true"
import style1 from "./addDep.vue?vue&type=style&index=1&id=4022ba02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4022ba02",
  null
  
)

export default component.exports